import { TextInput, SelectInput } from 'react-admin';

export const getGoogleAdsBridgesFilters = () => [
  <TextInput
    source="q"
    label="ID, Account ID, Account Name"
    alwaysOn
    sx={{ width: '400px' }}
  />,
  <SelectInput
    source="enabled"
    label="Enabled"
    choices={[
      { id: true, name: 'Yes' },
      { id: false, name: 'No' }
    ]}
    className="input-width-md"
  />
];
